import styled from 'styled-components';
import { FormControl, Grid2 } from '@mui/material';

export const TextStyled = styled.h4`
  margin: 0;
  color: ${(props) => props.theme.palette.primary.main};
  font-size: 24px;
  line-height: 30px;
`;

export const TextWrapperStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  h4 {
    text-align: center;
  }

  button {
    max-width: 300px;
    margin: 14px 0 14px 0;
    padding: 16px 34px;
    border-radius: 30px;
    &:disabled {
      background-color: #b6b2a9;
    }
  }

  p { 
    margin-top: 0;
    color: ${(props) => props.theme.palette.primary.main};
  }
`;

export const FormControlStyled = styled(FormControl)`
  display: flex;
  align-items: center;
`;

export const GridStyled = styled(Grid2)`
  display: flex;
  width: 100%;
  justify-content: center;
  > div {
    text-align: center;
    width: fit-content;
    
  }
`;

export const WrapperStyled = styled.section`
  display: flex;
  flex-direction: column-reverse;
  justify-content: center;

  button:last-child {
    margin-bottom: 15px;
  }
  
  @media (min-width: 680px) {
    flex-direction: row;
    justify-content: space-between;

    button:last-child {
    margin-bottom: 0;
  }
  }
`;
